import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_EVENT_QUERY_KEY = 'woop-event';

const getWorkloadEventQueryKey = ({
  clusterId,
  eventId,
  createdAt,
}: { clusterId?: string; eventId?: string; createdAt?: string } = {}) =>
  [WOOP_EVENT_QUERY_KEY, clusterId, eventId, createdAt] as const;

type UseWorkloadEventQueryArgs = {
  clusterId: string;
  eventId: string;
  createdAt: string;
  enabled?: boolean;
};

const getWorkloadEventQueryOptions = ({
  clusterId,
  eventId,
  createdAt,
  enabled = true,
}: UseWorkloadEventQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadEventQueryKey({ clusterId, eventId, createdAt }),
    queryFn: async () => {
      const { data } = await apiClient.workloadOptimization.getEvent({
        clusterId,
        eventId,
        createdAt,
      });

      return data?.event;
    },
    enabled: enabled && !!clusterId && !!eventId && !!createdAt,
  });

export const useWorkloadEventQuery = (args: UseWorkloadEventQueryArgs) => {
  const { isLoading, data, error, refetch } = useQuery(
    getWorkloadEventQueryOptions(args)
  );

  return {
    isLoading,
    event: data,
    error,
    refetch,
  };
};
